var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56055 1.03906C7.56055 0.815286 7.47165 0.600675 7.31342 0.442441C7.15518 0.284207 6.94057 0.195312 6.7168 0.195312C6.49302 0.195312 6.27841 0.284207 6.12018 0.442441C5.96194 0.600675 5.87305 0.815286 5.87305 1.03906V5.82031H1.0918C0.86802 5.82031 0.653409 5.90921 0.495175 6.06744C0.336942 6.22567 0.248047 6.44029 0.248047 6.66406C0.248047 6.88784 0.336942 7.10245 0.495175 7.26068C0.653409 7.41892 0.86802 7.50781 1.0918 7.50781H5.87305V12.2891C5.87305 12.5128 5.96194 12.7274 6.12018 12.8857C6.27841 13.0439 6.49302 13.1328 6.7168 13.1328C6.94057 13.1328 7.15518 13.0439 7.31342 12.8857C7.47165 12.7274 7.56055 12.5128 7.56055 12.2891V7.50781H12.3418C12.5656 7.50781 12.7802 7.41892 12.9384 7.26068C13.0967 7.10245 13.1855 6.88784 13.1855 6.66406C13.1855 6.44029 13.0967 6.22567 12.9384 6.06744C12.7802 5.90921 12.5656 5.82031 12.3418 5.82031H7.56055V1.03906Z",
    fill: "#407DBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.865648173153b13564e2a95135ae287e.svg";
export { ForwardRef as ReactComponent };